import baseService from './baseService'

export const userService = {
  login,
  getDropdownData,
  register,
  init,
  resetPassword
}

function login (loginDto) {
  return baseService.postRequest('users/authenticate', loginDto)
}

function getDropdownData () {
  return baseService.getRequest('public/tdb/getRegistrationDropdownData')
}

function register (registrationDto) {
  return baseService.postRequest('public/tdb/auth/register', registrationDto)
}

function init (client) {
  return baseService.postRequest(`public/tdb/init`, { url: client })
}

function resetPassword (request) {
  return baseService.postRequest('public/tdb/auth/reset', request)
}
